import axios from 'axios';
import router from '@/router/index'
import { Notification } from 'element-ui';

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

let hasTip = false

const toLogin = () => {
    router.replace({
        path: '/login'
    });
}
const toHome = () => {
    router.replace({
        path: '/home'
    });
}

const isDev = process.env.NODE_ENV === 'development';

const service = axios.create({
    // baseURL: isDev ? 'http://192.168.8.123' : 'https://exp-api.vrbook.vip',
    timeout: 1000 * 12,
    baseURL: 'https://exp-api.vrbook.vip'
});

service.interceptors.request.use(
    config => {
        NProgress.start()
        config.headers.Authorization = window.localStorage.getItem('token')
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

service.interceptors.response.use(
    response => {
        NProgress.done()
        const res = response.data
        if (res.statusCode === 200) {
            return res
        } else if (res.statusCode === -200) {
            window.localStorage.clear();
            toLogin();
        } else {
            if (hasTip) {
                return
            } else {
                hasTip = true
                Notification({
                    type: 'error',
                    message: res.msg || 'Error',
                    duration: 2000,
                    title: 'ERROR',
                })
                setTimeout(() => {
                    hasTip = false
                }, 1000);
            }
            return Promise.reject(new Error(res.msg || 'Error'))
        }
    },
    error => {

        if (!hasTip) {
            hasTip = true
            Notification({
                type: 'error',
                message: error.message,
                duration: 2000,
                title: 'ERROR',
            })
            setTimeout(() => {
                hasTip = false
            }, 1000);
        }
        console.log('err' + error)
        NProgress.done();
        return Promise.reject(error)
    }
)

export default service;